import EASClient from './EASClient';

export const clientID = EASClient.clientID;
